import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="py-12 px-6 bg-ink border-t border-bone/10 text-center" data-id="element-74">
      <div className="max-w-editorial mx-auto" data-id="element-75">
        <p className="font-serif text-bone/90 text-lg mb-4" data-id="element-76">
          La Ansiedad Es Tu Síntoma, No Tu Identidad
        </p>
        <div className="text-bone/50 text-sm font-sans space-y-2" data-id="element-77">
          <p data-id="element-78">
            Producto digital. Acceso inmediato tras la confirmación de pago.
          </p>
          <p data-id="element-79">Pagos procesados de forma segura a través de Mercado Pago.</p>
          <p data-id="element-80">&copy; {currentYear} Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}